import ExternalLink from '../../../components/ExternalLink'
import { Page } from '../../types'

type ClientPythonDockerProps = {
    framework: string
    packageManager: string,
    requiresFullInstallation: boolean
}

const getBaseImage = (requiresFullInstallation: boolean) => 'gurobi/' + (requiresFullInstallation ? 'optimizer' : 'python')
const getBaseImageTag = (requiresFullInstallation: boolean) => getBaseImage(requiresFullInstallation) + ':latest'

const getDockerfile = ({ framework, requiresFullInstallation }: ClientPythonDockerProps) => {
    const baseImage = getBaseImageTag(requiresFullInstallation)
    const packages = framework
    
    return `FROM ${baseImage}

# Set the application directory
WORKDIR /app
${packages ? `
# Install additional dependencies 
RUN python -m pip install ${packages}
` : ''}
# Copy the application code
ADD app.py /app

# Execute the code
CMD ["python", "/app/app.py"]
`
}

const render = (props : ClientPythonDockerProps) => {
    const baseImage = getBaseImage(props.requiresFullInstallation)
    return <>
        <p>Below is a simple Docker file based on our publicly available <ExternalLink href={`https://hub.docker.com/r/${baseImage}`}><code>{baseImage}</code> base image</ExternalLink>. Note
            that you don't have to start from that base image. The underlying Dockerfile is available from
            our <ExternalLink href="https://github.com/Gurobi/docker-python">Github account</ExternalLink>.</p>
        <pre>{getDockerfile(props)}</pre>
    </>
}

const ClientPythonDocker : Page<ClientPythonDockerProps> = { key: 'client-python-docker', title: 'Create a Dockerfile', render }

export default ClientPythonDocker